<!-- Product creation form -->
<form [formGroup]="form" (ngSubmit)="createNew()">
    <div>
        <label for="nickname">Nickname:</label>
        <input type="text" id="nickname" formControlName="nickname">
    </div>
    <div>
        <label for="description">Description:</label>
        <input type="text" id="description" formControlName="description">
    </div>
    <div>
        <label for="active">Active:</label>
        <select id="active" formControlName="active">
            <option [ngValue]="true">True</option>
            <option [ngValue]="false">False</option>
        </select>
    </div>
    <div>
        <label for="currency">Currency:</label>
        <select formControlName="currency">
            <option>usd</option>
        </select>
    </div>
    <div>
        <label for="amount">Amount:</label>
        <input type="number" id="amount" formControlName="amount">
    </div>
    <div>
        <label for="productCategoryId">Product Category:</label>
        <select formControlName="productCategoryId">
            <option *ngFor="let productCategory of productCategories" [value]="productCategory.id">{{productCategory.name}}</option>
        </select>
    </div>
    <div>
        <label for="planId">Plan:</label>
        <select formControlName="planId">
            <option *ngFor="let plan of plans" [value]="plan.id">{{plan.planName}}</option>
        </select>
    </div>
    <div>
        <label for="glCodeId">GL Code:</label>
        <select formControlName="glCodeId">
            <option *ngFor="let glCode of glCodes" [value]="glCode.id">{{glCode.composedLabel}}</option>
        </select>
    </div>
    <button type="submit" [disabled]="form.invalid">Create Product</button>
</form>
<div *ngIf="id">Created Product ID: {{ id }}</div>

<!-- Show all products toggle -->
<button (click)="toggleShowProducts()">
    {{showProducts ? 'Hide Products' : 'Show All Products'}}
</button>

<!-- Table shows all products with controls for update and delete -->
<table *ngIf="showProducts">
    <thead>
        <tr>
            <th>ID</th>
            <th>Nickname</th>
            <th>Description</th>
            <th>Active</th>
            <th>Currency</th>
            <th>Amount</th>
            <th>Product Category ID</th>
            <th>Plan ID</th>
            <th>GL Code Id</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let product of products; let i = index">
            <td>{{product.id}}</td>
            <td>
                <input *ngIf="product.isEditing" type="text" [(ngModel)]="product.nickname">
                <span *ngIf="!product.isEditing">{{product.nickname}}</span>
            </td>
            <td>
                <input *ngIf="product.isEditing" type="text" [(ngModel)]="product.description">
                <span *ngIf="!product.isEditing">{{product.description}}</span>
            </td>
            <td>
                <select *ngIf="product.isEditing" [(ngModel)]="product.active">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                </select>
                <span *ngIf="!product.isEditing">{{product.active ? 'Yes' : 'No'}}</span>
            </td>
            <td>
                <select *ngIf="product.isEditing" [(ngModel)]="product.currency">
                    <option>usd</option>
                </select>
                <span *ngIf="!product.isEditing">{{product.currency}}</span>
            </td>
            <td>
                <input *ngIf="product.isEditing" type="number" [(ngModel)]="product.amount">
                <span *ngIf="!product.isEditing">{{product.amount}}</span>
            </td>
            <td>
                <select *ngIf="product.isEditing" [(ngModel)]="product.productCategoryId">
                    <option *ngFor="let productCategory of productCategories" [value]="productCategory.id">{{productCategory.name}}</option>
                </select>
                <span *ngIf="!product.isEditing">{{product.productCategoryId}}</span>
            </td>
            <td>
                <select *ngIf="product.isEditing" [(ngModel)]="product.planId">
                    <option *ngFor="let plan of plans" [value]="plan.id">{{plan.planName}}</option>
                </select>
                <span *ngIf="!product.isEditing">{{product.planId}}</span>
            </td>
            <td>
                <select *ngIf="product.isEditing" [(ngModel)]="product.glCodeId">
                    <option *ngFor="let glCode of glCodes" [value]="glCode.id">{{glCode.composedLabel}}</option>
                </select>
                <span *ngIf="!product.isEditing">{{product.glCodeId}}</span>
            </td>
            <td>
                <button *ngIf="!product.isEditing" (click)="editProduct(product)">Edit</button>
                <button *ngIf="product.isEditing" (click)="updateProduct(product)">Save</button>
                <button *ngIf="product.isEditing" (click)="cancelEditing(product)">Cancel</button>
                <button (click)="deleteProduct(product.id)">Delete</button>
              </td>
        </tr>
    </tbody>
</table>